import styled from "styled-components";

export const DatePickerWrapperStyles = styled.div`

input {
    margin: 0;
    text-align: center;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    appearance: none;
    border-radius: 0.375rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
input:focus {
    color: #212529;
    background-color: #fff;
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

`